/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService
 */

export const createPlaylistAssignmentsRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService',
  rpcName: 'createPlaylistAssignments',
  auth: 'app',
  fingerprint: 'y_bGk91ej9fdE9luwcsnUkMGDWyLBxrV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const assignPlaylistRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService',
  rpcName: 'assignPlaylist',
  auth: 'app',
  fingerprint: 'y_bGk91ej9fdE9luwcsnUkMGDWyLBxrV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPlaylistAssignmentsByIdsRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService',
  rpcName: 'getPlaylistAssignmentsByIds',
  auth: 'app',
  fingerprint: 'ReBStg24WCzdE9luwcsnUkMGDWyLBxrV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updatePlaylistAssignmentRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService',
  rpcName: 'updatePlaylistAssignment',
  auth: 'app',
  fingerprint: 'vUcUehvYL6ndE9luwcsnUkMGDWyLBxrV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePlaylistAssignmentRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService',
  rpcName: 'deletePlaylistAssignment',
  auth: 'app',
  fingerprint: 'gtcjvg8FffWH11L90Qs0lkMGDWyLBxrV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService',
  rpcName: 'search',
  auth: 'app',
  fingerprint: 'TAv5_m_dU8GxerVczKptKkMGDWyLBxrV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchAggregationRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.PlaylistAssignmentsChirpService',
  rpcName: 'searchAggregation',
  auth: 'app',
  fingerprint: 'RLGF7VBcLlsLIaxlGuMsEUMGDWyLBxrV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};